module.exports = __webpack_public_path__ + "img/flat_work1.d4913b23.jpg";